'use strict';

import $ from 'jquery';
import helper from './helper';

/**
 * Module contains checkout process functionality
 * and order functionality (mainly timers) that can be found in checkout and in own pages
 */
const checkout = {

  /**
   * Starts countdown timers for every `.js-countdown-timer` element.
   * Element has the following data-attributes:
   *  - expiration     : unix timestamp of expiration date (mandatory)
   *  - expiration-msg : Message that is shown when time runs out (optional)
   *  - redirect-url   : Url to redirect when time runs out (optional)
   *  - callback       : special function id to run when time runs out (optional)
   */
  startTimers: () => {
    const timers = [];

    // Special callbacks when timers reach zero
    const callbacks = {
      'user-reservations': (timer) => {
        // Removes the payment button when time runs out
        $(timer).closest('.user-orders__reservation').find('.js-proceed-to-payment').remove();
      }
    }

    $('.js-countdown-timer').each((i, element) => {
      const loadedTime = parseInt(element.dataset.now, 10);
      const expiration = parseInt(element.dataset.expiration, 10);
      const timeOffset = loadedTime - Date.now();
      const localExpiration = expiration - timeOffset;

      timers[i] = setInterval(() => {
        const remaining = localExpiration - Date.now();

        if(remaining <= 0) {
          clearTimeout(timers[i]);

          if(callbacks[element.dataset.callback]) {
            callbacks[element.dataset.callback](element);
          }

          if(element.dataset.redirectUrl) {
            // Do redirect and info user that time has expired
            if(element.dataset.expirationMsg) {
              alert(element.dataset.expirationMsg); // eslint-disable-line no-alert
            }
            window.location.href = element.dataset.redirectUrl;
          } else {
            if(element.dataset.expirationMsg) {
              element.innerText = element.dataset.expirationMsg;
            }
          }
        } else {
          element.innerText = helper.formatTimeLeftLong(remaining);
        }
      }, 1000);
    });
  },

  /**
   * Shows the user details form when btn is clicked
   */
  showUserDetailsForm: () => {
    $('.checkout__customer').addClass('checkout__customer--edit');
    // Checkbox is hidden when form is opened..
    // Yet server validation requires it, so need to tick it
    // Also checkbox cannot be required when it is hidden (browser complains)
    $('#details_ok').prop('checked', true).prop('required', false);
  },

  /**
   * Toggles online payment options
   * when payment method is selected
   *
   * @param {event} e - onchange event object
   */
  updatePaymentMethod: (e) => {
    $('.js-payment-provider').toggle(e.target.value === '9');
  },


  init: function() {
    // Init countdown timers
    this.startTimers();

    // On checkout pages only
    if($('.checkout').length) {

      // Click event for modify user details button
      $('.js-contact-details-button').on('click', () => {
        this.showUserDetailsForm();
      });

      // Payment method when billing is allowed
      const paymentSelect = $('#payment_method');
      if(paymentSelect.length) {
        paymentSelect.on('change', this.updatePaymentMethod).trigger('change');
      }
    }

    const $paymentRedirectForm = $('#stage-payment-redirect');
    if($paymentRedirectForm.length) {
      $paymentRedirectForm.on('submit', event => {
        event.preventDefault();
        this.extendCheckoutReservation(event);
      });
    }
  },

  extendCheckoutReservation: function(event) {
    const form = event.target;
    const cm_token = $('[name="cm_token"]').val();
    const productUuid = window.PRODUCT_UUID;
    const productUrl = $('.vehicle-data a[href^="/tuote/"]').attr('href');
    const expirationMessage = $('.js-countdown-timer').data('expirationMsg');

    $.ajax({
      method: 'POST',
      url: `/api/1.0.0/product/${ productUuid }/extendReservation`,
      data: JSON.stringify({ cm_token }),
      contentType: 'application/json'
    }).done(function(res){
      if(res.status === 'OK') {
        form.submit();
      } else {
        window.alert(expirationMessage);
        window.location = productUrl;
      }
    }).fail(function(res) {
      window.alert(expirationMessage);
      window.location = productUrl;
    });
  }
};

module.exports = checkout;
